var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SearchForm extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "submitToSearchPage", (event) => {
      const searchTerm = this.elements.input.value.trim();
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (!searchTerm.length) {
        return false;
      }
      window.location.assign(
        `${window.Shopify?.routes?.root || "/"}search?type=product&q=${encodeURIComponent(searchTerm)}`
      );
      return false;
    });
    __publicField(this, "onSearchesLiClick", ({ currentTarget }) => {
      var _a;
      const { value } = currentTarget.dataset;
      this.elements.input.value = value;
      (_a = this.elements.form) == null ? void 0 : _a.submit();
    });
    __publicField(this, "onFormSubmit", (event) => this.submitToSearchPage(event));
    __publicField(this, "onSearchKeydown", (event) => {
      if (event.key === "Enter") {
        this.submitToSearchPage(event);
      }
    });
    __publicField(this, "onSearchButtonClick", (event) => this.submitToSearchPage(event));
    this.getElements();
    this.parseKeywordCollections();
    this.setupEventListeners();
  }
  getElements() {
    this.elements = {
      form: this.querySelector('form[role="search"]'),
      input: this.querySelector('input[type="search"]'),
      submit: this.querySelector('form[role="search"] button[type="submit"]'),
      searchesLi: this.querySelectorAll("#search-drawer-searches li")
    };
  }
  parseKeywordCollections() {
    this.keywordMap = {};
    const keywordCollections = this.dataset.keywordCollections;
    if (keywordCollections) {
      const lines = keywordCollections.split("\n");
      lines.forEach((line) => {
        const trimmedLine = line.trim();
        if (trimmedLine && trimmedLine.includes(":")) {
          const [keyword, collectionHandle] = trimmedLine.split(":").map((s) => s.trim());
          if (keyword && collectionHandle) {
            this.keywordMap[keyword.toLowerCase()] = collectionHandle;
          }
        }
      });
    }
  }
  getCollectionHandleForKeyword(searchTerm) {
    return this.keywordMap[searchTerm.toLowerCase()] || null;
  }
  setupEventListeners() {
    this.elements.searchesLi.forEach((element) => {
      element.addEventListener("click", this.onSearchesLiClick);
    });
    if (this.elements.form) {
      this.elements.form.addEventListener("submit", this.onFormSubmit, true);
    }
    this.elements.input?.addEventListener("keydown", this.onSearchKeydown, true);
    this.elements.submit?.addEventListener("click", this.onSearchButtonClick, true);
  }
}
customElements.define("search-form", SearchForm);
